<template>
  <div class="d-block d-md-none">{{ column }}</div>
  <div>
    <template v-for="(item, index) in list" :key="item.id">
      <div v-if="index < 1">
        <DocumentCellDataTableComponent :item="item" />
      </div>
    </template>
    <button v-if="list.length > 1" class="other__link" @click="handleModalOpen(true)">{{ otherItemNumber }}</button>
  </div>
  <DocumentContentModalComponentModalComponent :opened="modalOpen" :list="list" @hidden="handleModalOpen(false)" />
</template>

<script>
import DocumentCellDataTableComponent from "@/components/data-table/cell/DocumentCellDataTableComponent.vue";
import DocumentContentModalComponentModalComponent from "@/components/data-table/modal/DocumentContentModalComponent.vue";

export default {
  name: "ListDocumentCellDataTableComponent",
  components: {
    DocumentContentModalComponentModalComponent,
    DocumentCellDataTableComponent,
  },
  props: {
    list: {
      type: Object,
      required: true,
    },
    column: {
      type: String,
      required: true,
    },
  },
  computed: {
    otherItemNumber() {
      const itemNumber = this.list.length - 1;
      const text = this.$tc("global.other", itemNumber > 1 ? 2 : 1).toLowerCase();
      return "+" + itemNumber + " " + text;
    },
  },
  data() {
    return {
      modalOpen: false,
    };
  },
  methods: {
    handleModalOpen(value) {
      this.modalOpen = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.other__link {
  margin-top: 5px;
  font-size: 12px;
  background-color: inherit;
  border: none;
  color: $info;
}
</style>
